<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_ii"></a>Also by Erica Spindler</p>
<p class="para"> </p>
<p class="center-para"><em>Breakneck<br/>Last Known Victim<br/>Copycat<br/>Killer Takes All<br/>See Jane Die<br/>In Silence<br/>Dead Run<br/>Bone Cold<br/>All Fall Down<br/>Cause for Alarm<br/>Shocking Pink<br/>Fortune<br/>Forbidden Fruit<br/>Red</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?730861ea